var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center mb-2"},[_c('svg',{staticClass:"shrink-0 w-4 h-4 mr-1 fill-dark-400"},[_c('use',{attrs:{"xlink:href":"#icon-info-solid"}})]),_c('span',{staticClass:"text-1xs text-dark-500",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }